import type React from 'react';

import {
  childrenWrapper,
  itemsWrapper,
  logoWithoutText,
  logoWithText,
} from './styles';
import { withStyles } from '@material-ui/core';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';

import { LogoFullIcon, LogoReducedIcon } from '../icons';

import { colors } from '../styles';

export interface NavbarProps {
  onClickLogo?: () => void;
  children?: JSX.Element;
}

const StyledAppBar = withStyles({
  root: {
    boxShadow: `0 1px 0 0 ${colors.gray.default}`,
    pointerEvents: 'auto',
  },
  // TODO TSC: fix "as any" on next line. Maybe it has something to do with multiple versions of '@material-ui/core'.
})(AppBar as any);

const StyledToolbar = withStyles({
  root: {
    backgroundColor: colors.white,
    color: colors.white,
    minHeight: '54px',
    height: '54px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: 0,
  },
})(Toolbar);

export const Navbar: React.FC<NavbarProps> = ({ onClickLogo, children }) => {
  return (
    <StyledAppBar position='static' color='default'>
      <StyledToolbar>
        <div className={itemsWrapper}>
          {/* Always displays only one of the logos based on media query */}
          <LogoFullIcon className={logoWithText} onClick={onClickLogo} />
          <LogoReducedIcon className={logoWithoutText} onClick={onClickLogo} />
        </div>

        {children && <div className={childrenWrapper}>{children}</div>}
      </StyledToolbar>
    </StyledAppBar>
  );
};
